import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { useI18n } from '../lib/i18n.js';

/**
 * Says, on every screen, that this deployment is a demonstration.
 *
 * The demo has no SMS gateway -- DLT registration with the carriers takes
 * weeks -- so the issue OTP is shown on screen instead of sent to the
 * officer's phone. That is a sensible thing to do for a demonstration and an
 * unacceptable thing to do with real Patta records, and the difference has to
 * be visible to anyone looking at the screen rather than buried in a
 * configuration file.
 *
 * The flag comes from the server's own configuration, not from the build, so
 * the same bundle is honest wherever it is deployed.
 */
export function useIsDemo(): boolean {
  const health = useQuery({
    queryKey: ['health'],
    queryFn: () => api<{ status: string; demo?: boolean }>('/health'),
    staleTime: 60 * 60_000,
    retry: false,
  });
  return health.data?.demo === true;
}

export function DemoBanner() {
  const { t } = useI18n();
  const isDemo = useIsDemo();

  if (!isDemo) return null;

  return (
    <div className="no-print border-b border-amber-line bg-amber-bg px-4 py-2 text-center text-[0.8125rem] text-amber-ink">
      <strong className="font-semibold">{t('demo.title')}</strong> — {t('demo.body')}
    </div>
  );
}
